// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"673":"10a7ba48","714":"5def2cc1","863":"ce50a4bf"}[chunkId] + ".chunk.css";
};